import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";

// Pass `off` to draw a slash through the icon (muted / camera off). The gap
// under the slash takes `slashGapColor`, normally the button background.
function SvgComponent({
  off = false,
  slashGapColor = "#E5484D",
  ...props
}: SvgProps & { off?: boolean; slashGapColor?: string }) {
  return (
    <Svg width={59} height={59} viewBox="0 0 59 59" fill="none" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.646 33.876a1.61 1.61 0 013.12.796 16.879 16.879 0 01-5.993 9.113 16.715 16.715 0 01-8.656 3.453v3.279h7.307a1.617 1.617 0 110 3.233H20.578a1.617 1.617 0 010-3.233h7.306v-3.28a16.714 16.714 0 01-8.655-3.452 16.88 16.88 0 01-5.993-9.113 1.61 1.61 0 013.12-.796c.757 2.951 2.5 5.528 4.856 7.358a13.474 13.474 0 008.289 2.848c3.115 0 5.994-1.065 8.29-2.848 2.355-1.83 4.097-4.407 4.855-7.358zM28.956 5.25c-4.851 0-8.835 3.901-8.97 8.72h3.995a1.617 1.617 0 110 3.234h-4v3.824h4a1.617 1.617 0 110 3.234h-4v3.824h4a1.617 1.617 0 110 3.233h-3.996c.136 4.82 4.12 8.72 8.97 8.72h1.09c4.852 0 8.836-3.9 8.971-8.72h-3.995a1.617 1.617 0 110-3.233h4v-3.824h-4a1.617 1.617 0 110-3.234h4v-3.824h-4a1.617 1.617 0 110-3.233h3.995c-.135-4.82-4.119-8.721-8.97-8.721h-1.09z"
        fill="#F6F7F9"
      />
      {off && (
        <>
          <Path
            d="M10 8L49 51"
            stroke={slashGapColor}
            strokeWidth={9}
            strokeLinecap="round"
          />
          <Path
            d="M10 8L49 51"
            stroke="#F6F7F9"
            strokeWidth={4}
            strokeLinecap="round"
          />
        </>
      )}
    </Svg>
  );
}

export default SvgComponent;
